<template>
    <v-container :key="fetchKey" fluid class="pa-0" style="height: inherit; background-color: white;">
        <v-row no-gutters align="stretch" style="height: inherit; overflow: auto;">

            <v-col :cols="isPhoneBool ? 12 : (editItem && editItem.ReplaceKeyWords && editItem.ReplaceKeyWords[0] ? 8 : 12)"
                class="px-3">
                <!-- 
                <v-row v-if="longDescription" no-gutters class="pt-3 px-3">
                    <v-col>
                        <v-alert dense outlined type="info" border="left" class="mb-0">
                            {{ longDescription }}
                        </v-alert>
                    </v-col>
                </v-row>
                -->

                <centered-loading v-if="isLoading" :displayBool="true" :completedBool="false"
                    :displayText="$t('servicesystem.common_objects.commonterms.loading_placeholder', { pkey: $t('servicesystem.common_objects.email_settings.email_template').toLowerCase() })"
                    class="ignoreodd" style="height: 80vh;">
                </centered-loading>

                <v-form v-else ref="emailForm" v-model="localFormValid">
                    <EmailEditContent :configKey="configKey" :item="editItem" :editMode="true" :handleFocus="() => { }"
                        :replaceKeyWords="editItem && editItem.ReplaceKeyWords">
                    </EmailEditContent>
                </v-form>
            </v-col>

            <EmailKeywordsNote :replaceKeyWords="editItem && editItem.ReplaceKeyWords">
            </EmailKeywordsNote>

        </v-row>
    </v-container>
</template>


<script>
import EmailEditContent from '@/views/admin/settings/email/EmailEditContent.vue';
import EmailKeywordsNote from '@/views/admin/settings/email/EmailKeywordsNote.vue';
import CenteredLoading from '@/components/Sections/CenteredLoading.vue';
import EmailTemplates from '@/helpers/Constants/EmailTemplates.js';

export default {
    name: 'ViewEmailSetting',
    props: {
        configKey: {
            type: String,
            required: true,
        },
    },
    components: {
        CenteredLoading,
        EmailEditContent,
        EmailKeywordsNote,
    },

    data() {
        return {
            isLoading: true,
            fetchKey: 1,
            localFormValid: true,
        }
    },

    mounted() {
        this.getTemplate();
    },

    methods: {
        async getTemplate() {
            this.isLoading = true;
            try {
                await this.$store.dispatch("EmailTemplatesStore/fetchTemplateByKey", this.configKey);
            } finally {
                this.fetchKey++;
                this.isLoading = false;
            }
        },

        validateAndSaveIfRequested() {
            // called when save is requested via store
            if (this.$refs.emailForm && this.$refs.emailForm.validate) {
                const valid = this.$refs.emailForm.validate();
                this.$store.dispatch("EmailTemplatesStore/setFormValid", valid);
                if (valid && this.isDirty) {
                    this.$store.dispatch("EmailTemplatesStore/saveCurrent");
                }
            } else {
                // Fallback: assume valid
                this.$store.dispatch("EmailTemplatesStore/setFormValid", true);
                if (this.isDirty) {
                    this.$store.dispatch("EmailTemplatesStore/saveCurrent");
                }
            }
        }
    },

    computed: {
        longDescription() {
            const meta = EmailTemplates[this.configKey];
            return meta?.descriptionLong || '';
        },

        editItem() {
            return this.$store.getters["EmailTemplatesStore/editItem"];
        },
        isDirty() {
            return this.$store.getters["EmailTemplatesStore/isDirty"];
        },

        saveRequestCounter() {
            return this.$store.getters["EmailTemplatesStore/saveRequestCounter"];
        },
    },

    watch: {
        configKey: function () {
            this.getTemplate();
        },
        localFormValid: function (val) {
            this.$store.dispatch("EmailTemplatesStore/setFormValid", val);
        },
        saveRequestCounter: function () {
            this.validateAndSaveIfRequested();
        },
    },
};
</script>


<style lang='scss' scoped></style>